import clsx from 'clsx';
import React, { useCallback } from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ArticleTableOfContents = _ref => {
  let {
    items,
    className = '',
    activeItemId = '',
    onActivate
  } = _ref;
  // Invoke onActivate callback and prevent event propagation
  const handleItemClick = useCallback((evt, item) => {
    if (onActivate) onActivate(item.id);
    evt.preventDefault();
  }, [onActivate]);
  return /*#__PURE__*/_jsxs("nav", {
    className: clsx(styles.container, className),
    children: [/*#__PURE__*/_jsx("strong", {
      className: styles.heading,
      children: "Table of Contents"
    }), /*#__PURE__*/_jsx("ol", {
      className: styles.list,
      children: items === null || items === void 0 ? void 0 : items.map((item, index) => /*#__PURE__*/_jsx("li", {
        className: clsx(styles.item, item.id === activeItemId ? styles['item--active'] : ''),
        children: /*#__PURE__*/_jsx("a", {
          className: styles.link,
          href: `#${item.id}` // @ts-ignore
          ,
          onClick: evt => handleItemClick(evt, item),
          children: item.name
        })
      }, index))
    })]
  });
};

export default ArticleTableOfContents;